import { render } from "./EmailAccess.vue?vue&type=template&id=50130c63"
import script from "./EmailAccess.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailAccess.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Paywall/EmailAccess.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50130c63"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50130c63', __exports__)) {
    api.reload('50130c63', __exports__)
  }
  
  module.hot.accept("./EmailAccess.vue?vue&type=template&id=50130c63", () => {
    api.rerender('50130c63', render)
  })

}


export default __exports__